(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.UnoGiftCapCore = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  const VERSION = '2.0.1';
  const CAP = 4;
  const STORAGE_PREFIX = 'unoGiftOrderV2:';

  const WRAPPER = Object.freeze({
    deodorantSexyBouquet: 55901958635688,
    deodorantSweetPony: 55901959946408,
    deodorantPearl: 55901959979176,
    deodorantFruity: 55901960011944,
    deodorantIceCool: 55901960044712,
    deodorantSporty: 55901960077480,
    deodorantVanilla: 55901960110248,
    deodorantVelvet: 55901960143016,
    deodorantCottonCandy: 55901960175784,
    deodorantOud: 55901960208552,
    handSoapGreenAppleMint: 55901960274088,
    handSoapTropicalFruitLemon: 55901960306856,
    petShampooConditioner: 55901960339624,
    dryOilBronze: 55901960372392,
    dryOilPink: 55901960405160,
  });

  const SHOWER_GIFT_WRAPPERS = [
    WRAPPER.deodorantSexyBouquet,
    WRAPPER.deodorantSweetPony,
    WRAPPER.deodorantPearl,
    WRAPPER.deodorantFruity,
    WRAPPER.deodorantIceCool,
    WRAPPER.deodorantSporty,
    WRAPPER.deodorantVanilla,
    WRAPPER.deodorantVelvet,
    WRAPPER.deodorantCottonCandy,
    WRAPPER.deodorantOud,
  ];

  const GROUPS = [
    { sourceVariantIds: [55767753883816,55767753916584,55767753949352,55767753982120,55767754014888,55767754047656,55767754080424,55767754113192,55767754145960,55767754178728], paidVariantId: 55901618012328, giftWrapperVariantIds: SHOWER_GIFT_WRAPPERS },
    { sourceVariantIds: [55773372711080,55773372743848,55773372776616,55773372809384,55773372842152,55773372874920,55773372907688,55773372940456,55773372973224,55773373005992], paidVariantId: 55901618110632, giftWrapperVariantIds: SHOWER_GIFT_WRAPPERS },
    { sourceVariantIds: [55773444931752,55773444964520,55773444997288,55773445030056,55773445062824,55773445095592,55773445128360,55773445161128,55773445193896,55773445226664], paidVariantId: 55901618045096, giftWrapperVariantIds: SHOWER_GIFT_WRAPPERS },
    { sourceVariantIds: [55773450305704,55773450338472,55773450371240,55773450404008,55773450436776,55773450469544,55773450502312,55773450535080,55773450567848,55773450600616], paidVariantId: 55901618143400, giftWrapperVariantIds: SHOWER_GIFT_WRAPPERS },
    { sourceVariantIds: [55773453090984,55773453123752,55773453156520,55773453189288,55773453222056,55773453254824,55773453287592,55773453320360,55773453353128,55773453385896], paidVariantId: 55901618077864, giftWrapperVariantIds: SHOWER_GIFT_WRAPPERS },
    { sourceVariantIds: [55773477699752], paidVariantId: 55901616898216, giftWrapperVariantIds: [WRAPPER.handSoapTropicalFruitLemon] },
    { sourceVariantIds: [55773572202664], paidVariantId: 55901618176168, giftWrapperVariantIds: [WRAPPER.handSoapGreenAppleMint] },
    { sourceVariantIds: [55773628661928], paidVariantId: 55901618405544, giftWrapperVariantIds: [WRAPPER.handSoapTropicalFruitLemon] },
    { sourceVariantIds: [55773630595240], paidVariantId: 55901618307240, giftWrapperVariantIds: [WRAPPER.handSoapGreenAppleMint] },
    { sourceVariantIds: [55773631381672], paidVariantId: 55901618340008, giftWrapperVariantIds: [WRAPPER.handSoapTropicalFruitLemon] },
    { sourceVariantIds: [55773632069800], paidVariantId: 55901618372776, giftWrapperVariantIds: [WRAPPER.handSoapGreenAppleMint] },
    { sourceVariantIds: [55773633052840], paidVariantId: 55901618438312, giftWrapperVariantIds: [WRAPPER.handSoapTropicalFruitLemon] },
    { sourceVariantIds: [55773639475368], paidVariantId: 55901618471080, giftWrapperVariantIds: [WRAPPER.handSoapGreenAppleMint] },
    { sourceVariantIds: [55773641343144], paidVariantId: 55901618733224, giftWrapperVariantIds: [WRAPPER.handSoapTropicalFruitLemon] },
    { sourceVariantIds: [55773642686632], paidVariantId: 55901618700456, giftWrapperVariantIds: [WRAPPER.handSoapGreenAppleMint] },
    { sourceVariantIds: [55775040340136], paidVariantId: 55901618765992, giftWrapperVariantIds: [WRAPPER.petShampooConditioner] },
    { sourceVariantIds: [55775084773544], paidVariantId: 55901618798760, giftWrapperVariantIds: [WRAPPER.petShampooConditioner] },
    { sourceVariantIds: [55775094472872], paidVariantId: 55901618864296, giftWrapperVariantIds: [WRAPPER.petShampooConditioner] },
    { sourceVariantIds: [55777087750312], paidVariantId: 55901618831528, giftWrapperVariantIds: [WRAPPER.petShampooConditioner] },
    { sourceVariantIds: [55777225179304], paidVariantId: 55901619159208, legacyPartialVariantIds: [55901619060904], giftWrapperVariantIds: [WRAPPER.dryOilBronze, WRAPPER.petShampooConditioner] },
    { sourceVariantIds: [55777229144232], paidVariantId: 55901619093672, legacyPartialVariantIds: [55901619126440], giftWrapperVariantIds: [WRAPPER.dryOilPink, WRAPPER.petShampooConditioner] },
  ];

  function buildConfig(sourceOrder) {
    const sources = {};
    const wrapperVariantIds = new Set(Object.values(WRAPPER));
    const paidVariantIds = new Set();
    const legacyPartialVariantIds = new Set();
    for (const group of GROUPS) {
      paidVariantIds.add(Number(group.paidVariantId));
      for (const id of group.legacyPartialVariantIds || []) legacyPartialVariantIds.add(Number(id));
      group.sourceVariantIds.forEach((sourceVariantId, index) => {
        const gifts = group.giftWrapperVariantIds.length === group.sourceVariantIds.length && group.sourceVariantIds.length > 1
          ? [Number(group.giftWrapperVariantIds[index])]
          : group.giftWrapperVariantIds.map(Number);
        sources[String(sourceVariantId)] = {
          paidVariantId: Number(group.paidVariantId),
          legacyPartialVariantIds: (group.legacyPartialVariantIds || []).map(Number),
          giftWrapperVariantIds: gifts,
        };
      });
    }
    return {
      cap: CAP,
      sources,
      wrapperVariantIds,
      paidVariantIds,
      legacyPartialVariantIds,
      sourceOrder: Array.isArray(sourceOrder) ? sourceOrder.map(Number) : [],
    };
  }

  function numeric(value) {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function sourceVariantIdForItem(item, config) {
    const variantId = numeric(item?.variant_id);
    if (variantId == null) return null;
    if (config.wrapperVariantIds.has(variantId)) return null;
    if (config.sources[String(variantId)]) return variantId;

    const props = item.properties || {};
    const sourceFromShadow = numeric(props._uno_gc4_source_variant ?? props._uno_gift_source_variant);
    if (sourceFromShadow == null || !config.sources[String(sourceFromShadow)]) return null;
    const rule = config.sources[String(sourceFromShadow)];
    const isKnownPaid = variantId === Number(rule.paidVariantId);
    const isLegacyPartial = (rule.legacyPartialVariantIds || []).includes(variantId);
    return isKnownPaid || isLegacyPartial ? sourceFromShadow : null;
  }

  function isManagedPaidOrLegacyItem(item, config) {
    const variantId = numeric(item?.variant_id);
    if (variantId == null) return false;
    if (config.sources[String(variantId)]) return true;
    if (config.paidVariantIds.has(variantId) || config.legacyPartialVariantIds.has(variantId)) return true;
    return sourceVariantIdForItem(item, config) != null;
  }

  function buildLogicalGroups(cart, config) {
    const groups = [];
    const bySource = new Map();
    for (const item of cart.items || []) {
      const sourceVariantId = sourceVariantIdForItem(item, config);
      if (sourceVariantId == null) continue;
      let group = bySource.get(sourceVariantId);
      if (!group) {
        group = { sourceVariantId, quantity: 0, items: [] };
        bySource.set(sourceVariantId, group);
        groups.push(group);
      }
      group.quantity += Math.max(0, Number(item.quantity || 0));
      group.items.push(item);
    }
    const sourceOrder = Array.isArray(config.sourceOrder) ? config.sourceOrder.map(Number) : [];
    if (sourceOrder.length) {
      const rank = new Map(sourceOrder.map((id, index) => [Number(id), index]));
      groups.sort((a, b) => {
        const aRank = rank.has(Number(a.sourceVariantId)) ? rank.get(Number(a.sourceVariantId)) : Number.MAX_SAFE_INTEGER;
        const bRank = rank.has(Number(b.sourceVariantId)) ? rank.get(Number(b.sourceVariantId)) : Number.MAX_SAFE_INTEGER;
        return aRank - bRank;
      });
    }
    return groups;
  }

  function planGiftCap(cart, config) {
    let remaining = Math.max(0, Number(config.cap || 0));
    const gifts = {};
    const groups = buildLogicalGroups(cart, config).map((group) => {
      const rule = config.sources[String(group.sourceVariantId)];
      let giftCount = 0;
      for (let unit = 0; unit < group.quantity && remaining > 0; unit += 1) {
        for (const wrapperVariantId of rule.giftWrapperVariantIds || []) {
          if (remaining <= 0) break;
          const key = String(wrapperVariantId);
          gifts[key] = Number(gifts[key] || 0) + 1;
          remaining -= 1;
          giftCount += 1;
        }
      }
      return {
        sourceVariantId: Number(group.sourceVariantId),
        quantity: Number(group.quantity),
        paidVariantId: Number(rule.paidVariantId),
        giftCount,
      };
    });
    return { groups, gifts, giftCount: Object.values(gifts).reduce((sum, qty) => sum + Number(qty || 0), 0), remaining };
  }

  function paidProperties(sourceVariantId) {
    return {
      _uno_gc4_shadow: '1',
      _uno_gc4_source_variant: String(sourceVariantId),
    };
  }

  function giftProperties() {
    return { _uno_gc4_gift: '1' };
  }

  function isDesiredPaidLine(item, sourceVariantId, rule) {
    const props = item.properties || {};
    return Number(item.variant_id) === Number(rule.paidVariantId)
      && String(props._uno_gc4_source_variant || '') === String(sourceVariantId)
      && String(props._uno_gc4_shadow || '') === '1';
  }

  function managedOrderNeedsRepair(cart, config) {
    let seenGift = false;
    for (const item of cart.items || []) {
      const variantId = numeric(item?.variant_id);
      if (variantId != null && config.wrapperVariantIds.has(variantId)) {
        seenGift = true;
        continue;
      }
      if (seenGift && isManagedPaidOrLegacyItem(item, config)) return true;
    }
    return false;
  }

  function buildCanonicalOrderRepair(cart, config, plan) {
    const updates = {};
    for (const item of cart.items || []) {
      const variantId = numeric(item?.variant_id);
      const isGift = variantId != null && config.wrapperVariantIds.has(variantId);
      if (isGift || isManagedPaidOrLegacyItem(item, config)) updates[item.key] = 0;
    }

    const paidAdds = buildLogicalGroups(cart, config)
      .filter((group) => group.quantity > 0)
      .map((group) => {
        const sourceVariantId = Number(group.sourceVariantId);
        const rule = config.sources[String(sourceVariantId)];
        return { id: Number(rule.paidVariantId), quantity: Number(group.quantity), properties: paidProperties(sourceVariantId) };
      });

    const giftAdds = [];
    for (const wrapperVariantId of config.wrapperVariantIds) {
      const desiredQty = Number(plan.gifts[String(wrapperVariantId)] || 0);
      if (desiredQty > 0) giftAdds.push({ id: Number(wrapperVariantId), quantity: desiredQty, properties: giftProperties() });
    }

    return { updates, adds: giftAdds.concat(paidAdds.reverse()), plan };
  }

  function buildReconciliation(cart, config) {
    const plan = planGiftCap(cart, config);
    if (managedOrderNeedsRepair(cart, config)) return buildCanonicalOrderRepair(cart, config, plan);
    const updates = {};
    const paidAdds = [];
    const giftAdds = [];
    const groupedItemKeys = new Set();

    for (const group of buildLogicalGroups(cart, config)) {
      const sourceVariantId = Number(group.sourceVariantId);
      const rule = config.sources[String(sourceVariantId)];
      if (!rule || group.quantity <= 0) continue;
      const desiredPaid = group.items.filter((item) => isDesiredPaidLine(item, sourceVariantId, rule));
      const keeper = desiredPaid[0] || null;
      if (keeper) {
        groupedItemKeys.add(keeper.key);
        if (Number(keeper.quantity) !== Number(group.quantity)) updates[keeper.key] = Number(group.quantity);
      } else {
        paidAdds.push({ id: Number(rule.paidVariantId), quantity: Number(group.quantity), properties: paidProperties(sourceVariantId) });
      }
      for (const item of group.items) {
        groupedItemKeys.add(item.key);
        if (!keeper || item.key !== keeper.key) updates[item.key] = 0;
      }
    }

    // Remove unmanaged direct adds of paid/legacy shadow variants.
    for (const item of cart.items || []) {
      if (groupedItemKeys.has(item.key)) continue;
      if (isManagedPaidOrLegacyItem(item, config)) updates[item.key] = 0;
    }

    const wrapperLines = new Map();
    for (const item of cart.items || []) {
      const variantId = numeric(item.variant_id);
      if (variantId == null || !config.wrapperVariantIds.has(variantId)) continue;
      if (!wrapperLines.has(variantId)) wrapperLines.set(variantId, []);
      wrapperLines.get(variantId).push(item);
    }

    for (const wrapperVariantId of config.wrapperVariantIds) {
      const desiredQty = Number(plan.gifts[String(wrapperVariantId)] || 0);
      const lines = wrapperLines.get(wrapperVariantId) || [];
      const keeper = lines[0] || null;
      if (keeper) {
        if (Number(keeper.quantity) !== desiredQty) updates[keeper.key] = desiredQty;
        for (let i = 1; i < lines.length; i += 1) updates[lines[i].key] = 0;
      } else if (desiredQty > 0) {
        giftAdds.push({ id: Number(wrapperVariantId), quantity: desiredQty, properties: giftProperties() });
      }
    }

    const adds = giftAdds.concat(paidAdds.reverse());
    return { updates, adds, plan };
  }

  function getPersistentSourceOrder(cart, config, storage) {
    const physical = [];
    const seen = new Set();
    for (const item of cart.items || []) {
      const sourceVariantId = sourceVariantIdForItem(item, config);
      if (sourceVariantId == null || seen.has(sourceVariantId)) continue;
      seen.add(sourceVariantId);
      physical.push(sourceVariantId);
    }
    if (!physical.length) return [];
    if (!storage || !cart.token) return physical;
    const key = `${STORAGE_PREFIX}${cart.token}`;
    let persisted = [];
    try {
      const parsed = JSON.parse(storage.getItem(key) || '[]');
      if (Array.isArray(parsed)) persisted = parsed.map(Number).filter(Number.isFinite);
    } catch (_) {
      persisted = [];
    }
    const currentSet = new Set(physical.map(Number));
    const next = [];
    const added = new Set();
    for (const id of persisted) {
      if (currentSet.has(id) && !added.has(id)) {
        next.push(id);
        added.add(id);
      }
    }
    for (const id of physical) {
      if (!added.has(id)) {
        next.push(id);
        added.add(id);
      }
    }
    try { storage.setItem(key, JSON.stringify(next)); } catch (_) {}
    return next;
  }

  function ajaxJsonUrl(url) {
    if (!url) return '';
    return /\.js(?:\?|$)/.test(url) ? url : `${url}.js`;
  }

  return {
    VERSION,
    CAP,
    WRAPPER,
    GROUPS,
    buildConfig,
    sourceVariantIdForItem,
    buildLogicalGroups,
    planGiftCap,
    buildReconciliation,
    getPersistentSourceOrder,
    ajaxJsonUrl,
  };
});
